module.exports = __webpack_public_path__ + "media/a1.b354f546.mp3";